import React, { Component } from "react";
import { Redirect } from "react-router";
import InputHandler from "../../shared/javascript/InputHandler";
import SubmissionHandler from "../../shared/javascript/SubmissionHandler";
import { RadioGroup } from "../../shared/Components/RadioGroup";
import { CheckboxGroup } from "../../shared/Components/CheckboxGroup";
import { Textbox } from "../../shared/Components/Textbox";
import { LoadingModal } from "../../shared/Components/LoadingModal";
import error_messages from "./error_messages.json";
import fllogo from "../../../images/fllogo.png";
import fllogo2 from "../../../images/fllogo2.png";
import ppo from "../../../images/ppo.png";

var inputHandler = new InputHandler(error_messages);
var submissionHandler = new SubmissionHandler(error_messages);

export class Prevalidation extends Component {
  displayName = Prevalidation.name;
  constructor(props) {
    super(props);
    this.state = {
      user_browser: navigator.userAgent,
      endpoint: "/api/florida/dentalforhealth/prevalidate",
      errors: {
        referral: "",
        other_referral: "",
        conditions: "",
        member_id: "",
        group_number: "",
        default_error: ""
      },
      user_input: {
        referrals: {
          selected_option: "",
          options: {
            special_delivery_nurse: {
              label: "Special Delivery Nurse",
              is_checked: false
            },
            case_manager: {
              label: "Case Manager",
              is_checked: false
            },
            dental_office: {
              label: "Dental Office",
              is_checked: false
            },
            care_coordinator: {
              label: "Care Coordinator",
              is_checked: false
            },
            other: {
              label: "Other",
              is_checked: false
            }
          }
        },
        other_referral: "",
        conditions: {
          diabetes: {
            label: "Diabetes",
            is_checked: false
          },
          coronary_artery_disease: {
            label: "Coronary Artery Disease",
            is_checked: false
          },
          stroke: {
            label: "Stroke",
            is_checked: false
          },
          oral_cancer: {
            label: "Oral Cancer",
            is_checked: false
          },
          head_and_neck_cancer: {
            label: "Head and Neck Cancer",
            is_checked: false
          },
          sjogrens: {
            label: "Sjögren's Syndrome",
            is_checked: false
          },
          pregnancy: {
            label: "Pregnancy",
            is_checked: false
          },
					copd: {
            label: "Chronic Obstructive Pulmonary Disease",
            is_checked: false
          },
					esrd: {
            label: "End State Renal Disease",
            is_checked: false
          },
					mets: {
            label: "Metabolic Syndrome",
            is_checked: false
          },
        },
        member_id: ""
      },
      form_is_valid: false,
      is_loading: false,
      success: false
    };
  }

  render = () => {
    const {
      errors,
      user_input,
      is_loading,
      form_is_valid,
      success
    } = this.state;

    var referenceTextDisplay = <br />;
    // if 'other' under referral is selected, allow user to enter text
    if (user_input.referrals.selected_option === "other") {
      referenceTextDisplay = (
        <div className="row">
          <div className="col-md-6">
            <Textbox
              label_name="Please tell us who referred you."
              name="other_referral"
              placeholder="Other Referral"
              maxLength="25"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
              required={true}
            />
            {errors.other_referral}
          </div>
        </div>
      );
    } else if (user_input.referrals.selected_option !== "other") {
      // assure submission is available if user clicks away from 'other'
      user_input.other_referral = "";
      errors.other_referral = "";
    }

    var page = (
      <div className="container padding-top">
        <h1>
          Enroll in Oral Health for Overall Health
        </h1>
        <div className="alert alert-info alert-dismissable">
          <button
            type="button"
            className="close button button-primary buttonBlue close-btn"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <p>
            To participate in the Oral Health for Overall Health<sup>SM</sup> 
            &nbsp;program you must be enrolled in a dental plan offered by Florida 
            Blue and have at least one eligible medical condition (see below). 
            Note: It may take up to a month for us to process your enrollment. 
            Once your enrollment is processed, you will receive a welcome 
            letter in the mail. For more information, contact customer service 
            at 888-223-4892.
          </p>
          <p>
            Oral Health for Overall Health benefits are not
            available to members of BlueDental Care prepaid plans.
          </p>
        </div>
        <h2>
          Am I eligible?
        </h2>
        <p>
          You may be eligible to receive additional benefits available through 
          the Oral Health for Overall Health program if you have one of the 
          BlueDental plans listed below, and have been diagnosed with diabetes, 
          coronary artery disease, Sjӧgren’s syndrome, COPD, end-stage renal 
          disease, metabolic syndrome, oral, head and neck cancers, have 
          suffered a stroke, or are pregnant.
        </p>
        <ul>
          <li>Blue Dental Choice</li>
          <li>Blue Dental Choice Plus</li>
          <li>Blue Dental Copayment</li>
					<li>Medicare Advantage</li>
        </ul>
        <hr />
        <h3>Member Enroll</h3>
        <RadioGroup
          label_name="How did you hear about Oral Health for Overall Health?"
          radioButtons={user_input.referrals}
          required={true}
          onChange={e =>
            inputHandler.handleRadioGroupChange(e, this, "referrals")
          }
        />
        {referenceTextDisplay}
        {errors.referrals}
        <CheckboxGroup
          name="conditions"
          label_name="Check the eligible program condition(s) that you have:"
          checkboxes={user_input.conditions}
          onChange={e =>
            inputHandler.handleCheckboxGroupChange(e, this, "conditions")
          }
          required={true}
        ></CheckboxGroup>
        {errors.conditions}
        <br />
        <div className="row">
          <div className="col-md-6">
            <Textbox
              name="member_id"
              label_name="Member Being Enrolled ID"
              required={true}
              placeholder="Member ID"
              maxLength="11"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
            />
            {errors.member_id}
          </div>
        </div>
        <h3>Sample ID Cards:</h3>
        <div className="row">
          <div className="col">
            <div className="row id-card-display">
              <div>
                <div className="id-card">
                  <div className="row">
                    <img className="id-card-logo" src={fllogo} />
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col">
                      <p>Member Name</p>
                      <p>
                        <strong>John Q. Sample</strong>
                      </p>
                      <p>Member Number</p>
                      <p>
                        <span className="card-tooltip highlight-card-text">
                          124L78
                          <span className="tooltiptext">
                          If the member number displayed on your ID card only has 6 digits, please enter all 6 digits.
                          </span>
                        </span>
                      </p>
                    </div>
                    <div className="col">
                      <p>
                        Group Number <strong>12345</strong>
                      </p>
                      <p>Coverage Type:</p>
                      <p>
                        <strong>FAMILY</strong>
                      </p>
                      <p>Plan Type:</p>
                      <p>
                        <strong>GROUP</strong>
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <p className="col"></p>
                    <p className="col">BlueDental Choice</p>
                  </div>
                </div>
                <div className="row">
                  <div className="id-card-info col">
                    <span className="tooltiptext">
                    If the member number displayed on your ID card only has 6 digits, please enter all 6 digits.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="row id-card-display">
              <div>
                <div className="id-card">
                  <div className="row">
                    <img className="id-card-logo" src={fllogo2} />
                    <div className="col">
                      <br />
                      <div className="col">BlueOptions</div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5">
                      <hr />
                      <p>
                        <strong>SUB TUNA</strong>
                      </p>
                      <p>
                        <strong>Member Number</strong>
                      </p>
                      <p>
                        <strong>
                          XJB
                          <span className="card-tooltip highlight-card-text">
                            H97557963
                            <span className="tooltiptext">
                            Please enter only the highlighted digits. Any digits before the ‘H’ should not be entered. 
                            </span>
                          </span>
                        </strong>
                      </p>
                      <hr />
                      <br />
                      <hr />
                    </div>
                    <div className="col-5">
                      <hr />
                      <p>
                        <strong>BC 090 BS 590</strong>
                      </p>
                      <p>
                        <strong>Rx BIN 01283</strong>
                      </p>
                      <p>
                        <strong>PCN FLBC</strong>
                      </p>
                      <hr />
                      <p>
                        <strong>Group Number 90102</strong>
                      </p>
                      <hr />
                    </div>
                    <div className="col">
                      <img src={ppo} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="id-card-info col">
                  Please enter only the highlighted digits. Any digits before the ‘H’ should not be entered. 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="form-group">
          <input
            disabled={!form_is_valid}
            type="submit"
            className="btn btn-secondary"
            onClick={e =>
              submissionHandler.BuildFLPrevalidation(this).handleSubmit(e)
            }
            value="CHECK ELIGIBILITY"
          />
          <div aria-hidden="true" id="required-description">
            <span aria-hidden="true" className="text-danger">
              *
            </span>
            Required field
          </div>
        </div>
        {errors.default_error}
      </div>
    );

    var modal = null;
    if (is_loading) {
      modal = <LoadingModal />;
    }

    var currentRoute = window.location.href.replace(/^.*\/\/[^\/]+/, "");
    var validationRoute = "/fl/dentalforhealth/validate";
    if (success && currentRoute !== validationRoute) {
      return (
        <Redirect
          to={{
            pathname: validationRoute,
            user_input,
            success
          }}
        />
      );
    }

    return (
      <div>
        {page}
        {modal}
      </div>
    );
  };
}
